export const NO_PIC_PROFILE="https://i1.wp.com/static.teamtreehouse.com/assets/content/default_avatar-ea7cf6abde4eec089a4e03cc925d0e893e428b2b6971b12405a9b118c837eaa2.png?ssl=1";


// WEBPACK FOOTER //
// ./src/constants/profileConstant.js